// Temp redirect modal for content where language version does not exist
export const checkAvailableLangVersion = (url) => {
    fetch(`/common/sharedview/IsAvailableForLanguage?url=${url}`)
        .then(response => response.json())
        .then(data => {
            if (!data.IsSuccess) { showModalBootstrap(data) }
            else { window.location.href = url }
        })
        .catch(error => console.error(error));
}

const showModalBootstrap = (data) => {
    // Show/hide the alternative link (language version that does exist)
    let altUrl = data.Url;
    const altLink = document.getElementById('alternativeLink');
    if (altUrl) { altLink.href = '/'+altUrl; altLink.style.display = ''; }
    else { altLink.style.display = 'none'; }

    $('#langCheckModal').modal('show');
}

/*export const switchLanguageInUrl = (newLang) => {
    const currentUrl = window.location.href;
    const urlObj = new URL(currentUrl);
    const segments = urlObj.pathname.split('/');
    if (segments.length < 3) {
        return currentUrl;
    }
    segments[2] = newLang;
    urlObj.pathname = segments.join('/');

    return urlObj.pathname.toString();
}*/
